import { Link } from 'react-router-dom';
import type { CommodityDetail } from '../../../mocks/commodities';

interface Props {
  commodity: CommodityDetail;
}

export default function CommodityHero({ commodity }: Props) {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      {/* Fallback gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0c1f38] via-[#12304f] to-[#071525]" />
      {/* Background image */}
      <img
        src={commodity.heroImage}
        alt={commodity.label}
        className="absolute inset-0 w-full h-full object-cover object-top"
        onError={(e) => { (e.currentTarget as HTMLImageElement).style.opacity = '0'; }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#071525]/70 via-[#071525]/50 to-[#071525]/80" />

      {/* Breadcrumb */}
      <div className="absolute top-28 left-0 right-0 px-6 lg:px-16">
        <nav className="flex items-center gap-2 text-white/50 text-xs font-medium tracking-wider uppercase">
          <Link to="/" className="hover:text-[#d4571a] transition-colors duration-200 whitespace-nowrap">
            Home
          </Link>
          <i className="ri-arrow-right-s-line" />
          <Link to="/#products" className="hover:text-[#d4571a] transition-colors duration-200 whitespace-nowrap">
            What We Trade
          </Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-[#d4571a] whitespace-nowrap">{commodity.label}</span>
        </nav>
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col justify-end pb-16 px-6 lg:px-16 max-w-7xl mx-auto w-full">
        <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#d4571a]/20 border border-[#d4571a]/30 mb-6">
          <i className={`${commodity.icon} text-[#d4571a] text-2xl`} />
        </div>
        <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-3">
          What We Trade
        </p>
        <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-4 max-w-2xl">
          {commodity.label}
        </h1>
        <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-xl">
          {commodity.tagline}
        </p>
      </div>
    </section>
  );
}
